import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PrimeNgConfigService } from "./services/prime-ng-config.service";

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [PrimeNgConfigService],
})
export class PrimeNgConfigModule {}
